<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-2 ts-pt-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('restaurantSale.newOrder') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <form>
      <div class="ts-text-center ts-text-lg">{{ $t('restaurantSale.table') }}: <b class="text-info">{{ data.table_no }}</b></div>
      <ts-card-wrapper>
        <div class="form-group">
          <label class="col-form-label control-label required">{{
            $t('restaurantSale.numberOfCustomer')
          }}</label>
          <div>
            <RadioGroup v-model="model.num_customer" type="button" @on-change="onClickNumber">
              <Radio :label="1">1</Radio>
              <Radio :label="2">2</Radio>
              <Radio :label="3">3</Radio>
              <Radio :label="4">4</Radio>
              <Radio :label="5">5</Radio>
              <Radio :label="6">6</Radio>
              <Radio :label="7">7</Radio>
              <Radio :label="8">8</Radio>
              <Radio :label="9">9</Radio>
            </RadioGroup>
            <input
              ref="num_customer"
              type="number"
              class="form-control form-control-lg"
              v-model.number="model.num_customer"
              autofocus
              min="1"
            />
            <small
              >{{ $t('restaurantSale.note') }}:
              {{ data.num_pax_order_book_status }}</small
            >
          </div>
        </div>
      </ts-card-wrapper>
      <div class="btn-row">
        <ts-button
          type="submit"
          color="info"
          class="btn-block"
          @click.prevent="startOrder"
          :disabled="model.num_customer > 0 ? false : true"
          ><i class="fas fa-cart-plus"></i>
          {{ $t('restaurantSale.order') }}</ts-button
        >
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ['data'],
  name: 'input-number-customer-form',
  data () {
    return {
      model: {
        num_customer: 1
      }
    }
  },
  mounted () {
    this.$refs.num_customer.focus()
    this.$refs.num_customer.select()
  },
  methods: {
    startOrder () {
      this.$store.commit(
        'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
        this.data
      )
      this.$store.commit(
        'restaurantSale/counterCheckout/SET_NUMBER_CUSTOMERS',
        this.model.num_customer
      )
      this.$emit('close')
      this.$emit('before-close')
      this.$router.push({ name: 'customer-order' })
    },
    onClickNumber(){
      this.$refs.num_customer.focus()
    }
  }
}
</script>
<style scoped>
.btn-row .btn {
  padding: 15px 20px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}
</style>
